/* CRO cart nudge - 2026-08-07 (v2)
 * Replaces the hardcoded red "Please Meet Minimum Cart Value Of Rs300" wall
 * with a progress nudge plus a one-tap add that closes the gap.
 *
 * ---- THE ONLY TWO NUMBERS YOU NEED TO CHANGE ----
 * MIN_CART: minimum cart value, in paise. 30000 = Rs300.
 *           SET TO 0 = no minimum. Free shipping is the only ladder.
 * FREE_SHIP: free shipping threshold, in paise. 50000 = Rs500.
 *
 * v2 (2026-08-07): MIN_CART set to 0. The Rs300 was never enforced by any
 * live code - the Shiprocket app that owned it is no longer loading, so the
 * red banner was an orphaned label. Nothing to disable server-side.
 */
(function () {
  var MIN_CART = 0;
  var FREE_SHIP = 50000;

  var catalog = null;
  var busy = false;

  function rs(paise) {
    return '₹' + Math.ceil(paise / 100).toLocaleString('en-IN');
  }

  function getCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
  }

  function getCatalog() {
    if (catalog) return Promise.resolve(catalog);
    return fetch('/collections/all/products.json?limit=250')
      .then(function (r) { return r.json(); })
      .then(function (d) {
        var out = [];
        (d.products || []).forEach(function (p) {
          (p.variants || []).forEach(function (v) {
            if (v.available) {
              out.push({
                id: v.id,
                price: Math.round(parseFloat(v.price) * 100),
                title: p.title,
                variant: v.title,
                img: (p.images && p.images[0] && p.images[0].src) || ''
              });
            }
          });
        });
        catalog = out;
        return out;
      })
      .catch(function () { catalog = []; return catalog; });
  }

  /* Cheapest thing that actually closes the gap. Falls back to the
     cheapest item overall so the button is never empty-handed. */
  function pickAddon(items, gap, inCart) {
    var eligible = items.filter(function (i) { return inCart.indexOf(i.id) === -1; });
    var closers = eligible.filter(function (i) { return i.price >= gap; });
    var pool = closers.length ? closers : eligible;
    pool.sort(function (a, b) { return a.price - b.price; });
    return pool[0] || null;
  }

  /* Re-render the drawer in place via the Section Rendering API rather than
     reloading the page. Falls back to a reload if anything looks unfamiliar,
     because a working slow path beats a broken fast one. */
  function addToCart(id, btn) {
    if (busy) return;
    busy = true;
    btn.disabled = true;
    btn.textContent = 'Adding…';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{ id: id, quantity: 1 }],
        sections: 'cart-drawer,cart-icon-bubble',
        sections_url: window.location.pathname
      })
    })
      .then(function (r) { return r.json(); })
      .then(function (state) {
        var drawer = document.querySelector('cart-drawer');
        var canRender =
          drawer &&
          state &&
          state.sections &&
          state.sections['cart-drawer'] &&
          typeof drawer.renderContents === 'function';

        if (!canRender) {
          window.location.reload();
          return;
        }

        drawer.renderContents(state);
        busy = false;
        setTimeout(render, 150);
      })
      .catch(function () {
        window.location.reload();
      });
  }

  function render() {
    var ctas = document.querySelector('.cart__ctas');
    if (!ctas) return;

    /* Keep the original node in the DOM so anything still looking for #chk
       can find it, but stop it being a red wall. */
    var wall = document.getElementById('chk');
    if (wall) {
      wall.style.cssText = 'display:none !important;';
    }

    getCart().then(function (cart) {
      if (!cart || cart.item_count === 0) return;

      var total = cart.total_price;
      var inCart = (cart.items || []).map(function (i) { return i.id; });
      var box = document.getElementById('cro-cart-nudge');
      if (!box) {
        box = document.createElement('div');
        box.id = 'cro-cart-nudge';
        ctas.insertBefore(box, ctas.firstChild);
      }

      var gap, msg, tone;
      if (MIN_CART > 0 && total < MIN_CART) {
        gap = MIN_CART - total;
        msg = 'Add ' + rs(gap) + ' more to place your order.';
        tone = 'warn';
      } else if (total < FREE_SHIP) {
        gap = FREE_SHIP - total;
        msg = "You're " + rs(gap) + ' away from free shipping.';
        tone = 'info';
      } else {
        box.className = 'cro-nudge cro-nudge--done';
        box.innerHTML = '<p class="cro-nudge__msg">✓ Free shipping unlocked.</p>';
        return;
      }

      box.className = 'cro-nudge cro-nudge--' + tone;
      box.innerHTML = '<p class="cro-nudge__msg">' + msg + '</p>';

      getCatalog().then(function (items) {
        var pick = pickAddon(items, gap, inCart);
        if (!pick) return;
        var row = document.createElement('div');
        row.className = 'cro-nudge__addon';
        row.innerHTML =
          (pick.img ? '<img class="cro-nudge__img" src="' + pick.img + '" alt="" loading="lazy">' : '') +
          '<div class="cro-nudge__meta"><span class="cro-nudge__title"></span>' +
          '<span class="cro-nudge__price">' + rs(pick.price) + '</span></div>' +
          '<button type="button" class="cro-nudge__add">Add</button>';
        row.querySelector('.cro-nudge__title').textContent = pick.title;
        var btn = row.querySelector('.cro-nudge__add');
        btn.addEventListener('click', function () { addToCart(pick.id, btn); });
        box.appendChild(row);
      });
    });
  }

  function boot() {
    render();
    var drawer = document.querySelector('cart-drawer');
    if (drawer && window.MutationObserver) {
      var pending = null;
      new MutationObserver(function () {
        clearTimeout(pending);
        pending = setTimeout(render, 120);
      }).observe(drawer, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
